/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiEmailDtoCommunicationEventDto } from './WebApiEmailDtoCommunicationEventDto';
import {
    WebApiEmailDtoCommunicationEventDtoFromJSON,
    WebApiEmailDtoCommunicationEventDtoFromJSONTyped,
    WebApiEmailDtoCommunicationEventDtoToJSON,
} from './WebApiEmailDtoCommunicationEventDto';

/**
 * 
 * @export
 * @interface WebApiEmailDtoCommunicationReportDto
 */
export interface WebApiEmailDtoCommunicationReportDto {
    /**
     * 
     * @type {WebApiEmailDtoCommunicationEventDto}
     * @memberof WebApiEmailDtoCommunicationReportDto
     */
    event?: WebApiEmailDtoCommunicationEventDto;
    /**
     * 
     * @type {Array<WebApiEmailDtoCommunicationEventDto>}
     * @memberof WebApiEmailDtoCommunicationReportDto
     */
    subEvents?: Array<WebApiEmailDtoCommunicationEventDto> | null;
    /**
     * Current outcome of the message: latest error (unless delivered afterwards), otherwise latest event.
     * @type {string}
     * @memberof WebApiEmailDtoCommunicationReportDto
     */
    latestStatus?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiEmailDtoCommunicationReportDto
     */
    latestStatusDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoCommunicationReportDto
     */
    latestReason?: string | null;
}

/**
 * Check if a given object implements the WebApiEmailDtoCommunicationReportDto interface.
 */
export function instanceOfWebApiEmailDtoCommunicationReportDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiEmailDtoCommunicationReportDtoFromJSON(json: any): WebApiEmailDtoCommunicationReportDto {
    return WebApiEmailDtoCommunicationReportDtoFromJSONTyped(json, false);
}

export function WebApiEmailDtoCommunicationReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiEmailDtoCommunicationReportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event': !exists(json, 'event') ? undefined : WebApiEmailDtoCommunicationEventDtoFromJSON(json['event']),
        'subEvents': !exists(json, 'subEvents') ? undefined : (json['subEvents'] === null ? null : (json['subEvents'] as Array<any>).map(WebApiEmailDtoCommunicationEventDtoFromJSON)),
        'latestStatus': !exists(json, 'latestStatus') ? undefined : json['latestStatus'],
        'latestStatusDate': !exists(json, 'latestStatusDate') ? undefined : (json['latestStatusDate'] === null ? null : new Date(json['latestStatusDate'])),
        'latestReason': !exists(json, 'latestReason') ? undefined : json['latestReason'],
    };
}

export function WebApiEmailDtoCommunicationReportDtoToJSON(value?: WebApiEmailDtoCommunicationReportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event': WebApiEmailDtoCommunicationEventDtoToJSON(value.event),
        'subEvents': value.subEvents === undefined ? undefined : (value.subEvents === null ? null : (value.subEvents as Array<any>).map(WebApiEmailDtoCommunicationEventDtoToJSON)),
        'latestStatus': value.latestStatus,
        'latestStatusDate': value.latestStatusDate === undefined ? undefined : (value.latestStatusDate === null ? null : value.latestStatusDate.toISOString()),
        'latestReason': value.latestReason,
    };
}

